module.exports = __webpack_public_path__ + "static/media/web-search-spark-cards.107fceec.png";